module.exports = __webpack_public_path__ + "static/media/specification_en.65e1bb3a.md";